<div class="banner-editor-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <!-- Notificación de guardado exitoso -->
  <div class="save-notification" [class.show]="showSaveNotification">
    <div class="notification-content">
      <svg class="notification-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 6L9 17l-5-5"></path>
      </svg>
      <span class="notification-text">Proyecto guardado exitosamente</span>
    </div>
  </div>
  
  
  <div class="editor-content">
    <!-- Canvas Area -->
    <div class="canvas-area">
      <div class="canvas-wrapper">
        <canvas id="banner-canvas"></canvas>
      </div>
    </div>

    <!-- Barra de actividad (Activity Bar) - Lado derecho -->
    <div class="activity-bar">
      <button 
        class="activity-bar-item" 
        [class.active]="activePanel === 'config'"
        (click)="togglePanel('config')"
        title="Configuración"
      >
          <svg xmlns="http://www.w3.org/2000/svg"
            width="24" height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06
                  a2 2 0 0 1-2.83 2.83l-.06-.06
                  a1.65 1.65 0 0 0-1.82-.33
                  1.65 1.65 0 0 0-1 1.51V21
                  a2 2 0 0 1-4 0v-.09
                  a1.65 1.65 0 0 0-1-1.51
                  1.65 1.65 0 0 0-1.82.33l-.06.06
                  a2 2 0 1 1-2.83-2.83l.06-.06
                  a1.65 1.65 0 0 0 .33-1.82
                  1.65 1.65 0 0 0-1.51-1H3
                  a2 2 0 0 1 0-4h.09
                  a1.65 1.65 0 0 0 1.51-1
                  1.65 1.65 0 0 0-.33-1.82l-.06-.06
                  a2 2 0 1 1 2.83-2.83l.06.06
                  a1.65 1.65 0 0 0 1.82.33H9
                  a1.65 1.65 0 0 0 1-1.51V3
                  a2 2 0 0 1 4 0v.09
                  a1.65 1.65 0 0 0 1 1.51
                  1.65 1.65 0 0 0 1.82-.33l.06-.06
                  a2 2 0 1 1 2.83 2.83l-.06.06
                  a1.65 1.65 0 0 0-.33 1.82V9
                  a1.65 1.65 0 0 0 1.51 1H21
                  a2 2 0 0 1 0 4h-.09
                  a1.65 1.65 0 0 0-1.51 1z">
          </path>
        </svg>
      </button>
      
      <button 
        class="activity-bar-item" 
        [class.active]="activePanel === 'content'"
        (click)="togglePanel('content')"
        title="Contenido"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
      
      <button 
        class="activity-bar-item" 
        [class.active]="activePanel === 'elements'"
        (click)="togglePanel('elements')"
        title="Elementos"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </button>
    </div>
    
    <!-- Paneles laterales (Side Panels) -->
    <div class="side-panel" [class.open]="activePanel === 'config'">
      <div class="side-panel-header">
        <h2 class="side-panel-title">⚙️ Configuración</h2>
        <button class="side-panel-close" (click)="closePanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="side-panel-content">
        <!-- Sección de Configuración -->
        <div class="drawer-section">
          
          <!-- Dimensiones del Canvas -->
          <div class="control-section">
            <label class="section-label">Dimensiones del Banner - Flyer</label>
            
            <!-- Select de Plantillas -->
            <div class="control-item template-selector">
              <label class="control-label">Plantillas Sugeridas</label>
              <div class="custom-template-select">
                <button 
                  class="template-select-button" 
                  (click)="toggleTemplateDropdown()"
                  [class.expanded]="showTemplateDropdown"
                  type="button"
                >
                  <span class="template-select-text">
                    <span *ngIf="selectedTemplate === 'personalizado'">Personalizado</span>
                    <span *ngFor="let template of templates">
                      <span *ngIf="template.id === selectedTemplate && template.id !== 'personalizado'">
                        {{ template.name }}
                      </span>
                    </span>
                  </span>
                  <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="template-dropdown" [class.expanded]="showTemplateDropdown">
                  <div 
                    *ngFor="let template of templates" 
                    class="template-option"
                    [class.selected]="selectedTemplate === template.id"
                    [class]="'template-' + template.id"
                    (click)="selectTemplate(template.id)"
                  >
                    <div class="template-icon" *ngIf="template.id !== 'personalizado'">
                      <div class="template-icon-preview" [class]="getTemplateIconClass(template.id)"></div>
                    </div>
                    <div class="template-info">
                      <div class="template-name">{{ template.name }}</div>
                      <div class="template-description" *ngIf="template.description">{{ template.description }}</div>
                      <div class="template-dimensions" *ngIf="template.width && template.height">
                        {{ template.width }} × {{ template.height }} px
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="control-item">
              <label class="control-label">Ancho (px)</label>
              <input 
                type="number" 
                [(ngModel)]="canvasWidth"
                (change)="onCanvasSizeChange()"
                min="100"
                max="5000"
                step="1"
                class="size-input"
                [disabled]="selectedTemplate !== 'personalizado'"
              />
            </div>

            <div class="control-item">
              <label class="control-label">Alto (px)</label>
              <input 
                type="number" 
                [(ngModel)]="canvasHeight"
                (change)="onCanvasSizeChange()"
                min="100"
                max="5000"
                step="1"
                class="size-input"
                [disabled]="selectedTemplate !== 'personalizado'"
              />
            </div>
          </div>

          <!-- Color de Fondo -->
          <div class="control-section">
            <label class="section-label">Fondo</label>
            
            <!-- Selector de tipo de fondo -->
            <div class="control-item">
              <label class="control-label">Tipo de Fondo</label>
              <select [(ngModel)]="backgroundType" (change)="onBackgroundTypeChange()" class="font-select">
                <option value="solid">Color Sólido</option>
                <option value="gradient">Degradado</option>
              </select>
            </div>

            <!-- Fondo sólido -->
            <div *ngIf="backgroundType === 'solid'" class="control-item">
              <label class="control-label">Color</label>
              <div class="color-picker-group">
                <input 
                  type="color" 
                  [(ngModel)]="backgroundColor"
                  (change)="onBackgroundColorChange(backgroundColor)"
                  class="color-picker"
                />
                <input 
                  type="text" 
                  [(ngModel)]="backgroundColor"
                  (change)="onBackgroundColorChange(backgroundColor)"
                  class="color-input"
                  placeholder="#FFFFFF"
                />
              </div>
            </div>

            <!-- Fondo degradado -->
            <div *ngIf="backgroundType === 'gradient'">
              <div class="control-item">
                <label class="control-label">Color Inicio</label>
                <div class="color-picker-group">
                  <input 
                    type="color" 
                    [(ngModel)]="gradientColorStart"
                    (change)="onGradientChange()"
                    class="color-picker"
                  />
                  <input 
                    type="text" 
                    [(ngModel)]="gradientColorStart"
                    (change)="onGradientChange()"
                    class="color-input"
                    placeholder="#000000"
                  />
                </div>
              </div>

              <div class="control-item">
                <label class="control-label">Color Fin</label>
                <div class="color-picker-group">
                  <input 
                    type="color" 
                    [(ngModel)]="gradientColorEnd"
                    (change)="onGradientChange()"
                    class="color-picker"
                  />
                  <input 
                    type="text" 
                    [(ngModel)]="gradientColorEnd"
                    (change)="onGradientChange()"
                    class="color-input"
                    placeholder="#FF0000"
                  />
                </div>
              </div>

              <div class="control-item">
                <label class="control-label">Dirección</label>
                <select [(ngModel)]="gradientDirection" (change)="onGradientChange()" class="font-select">
                  <option value="horizontal">Horizontal (← →)</option>
                  <option value="vertical">Vertical (↑ ↓)</option>
                  <option value="diagonal">Diagonal (↗ ↘)</option>
                </select>
              </div>
            </div>

            <!-- Opciones de esquinas redondeadas -->
            <div class="control-item">
              <label class="control-label checkbox-label">
                <input 
                  type="checkbox" 
                  [(ngModel)]="roundedCorners"
                  (change)="onRoundedCornersChange()"
                  class="checkbox-input"
                />
                <span>Esquinas Redondeadas</span>
              </label>
            </div>

            <div *ngIf="roundedCorners" class="control-item">
              <label class="control-label">Radio de Esquinas</label>
              <div class="size-control">
                <input 
                  type="range" 
                  [(ngModel)]="cornerRadius"
                  (change)="onCornerRadiusChange()"
                  min="0"
                  max="100"
                  class="size-slider"
                />
                <span class="size-value">{{ cornerRadius }}px</span>
              </div>
            </div>

            <!-- Opciones de borde -->
            <div class="control-item">
              <label class="control-label checkbox-label">
                <input 
                  type="checkbox" 
                  [(ngModel)]="enableBorder"
                  (change)="onBorderChange()"
                  class="checkbox-input"
                />
                <span>Borde</span>
              </label>
            </div>

            <div *ngIf="enableBorder">
              <div class="control-item">
                <label class="control-label">Ancho del Borde</label>
                <div class="size-control">
                  <input 
                    type="range" 
                    [(ngModel)]="borderWidth"
                    (change)="onBorderWidthChange()"
                    min="1"
                    max="50"
                    class="size-slider"
                  />
                  <span class="size-value">{{ borderWidth }}px</span>
                </div>
              </div>

              <div class="control-item">
                <label class="control-label">Color del Borde</label>
                <div class="color-picker-group">
                  <input 
                    type="color" 
                    [(ngModel)]="borderColor"
                    (change)="onBorderColorChange()"
                    class="color-picker"
                  />
                  <input 
                    type="text" 
                    [(ngModel)]="borderColor"
                    (change)="onBorderColorChange()"
                    class="color-input"
                    placeholder="#000000"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <!-- Configuración de Exportación -->
          <div class="control-section">
            <label class="section-label">Exportación JPG</label>
            
            <div class="control-item">
              <label class="control-label">Calidad de Compresión</label>
              <div class="size-control">
                <input 
                  type="range" 
                  [(ngModel)]="jpgQuality"
                  min="10"
                  max="100"
                  step="1"
                  class="size-slider"
                />
                <span class="size-value">{{ jpgQuality }}%</span>
              </div>
              <div class="quality-hint">
                <small>
                  <span *ngIf="jpgQuality >= 90" class="quality-info high">Alta calidad (archivo más grande)</span>
                  <span *ngIf="jpgQuality >= 60 && jpgQuality < 90" class="quality-info medium">Calidad media (balanceado)</span>
                  <span *ngIf="jpgQuality < 60" class="quality-info low">Baja calidad (archivo más pequeño)</span>
                </small>
              </div>
            </div>
          </div>
          
          <!-- Acciones -->
          <div class="control-section actions-section">
            <!-- Botón Guardar (solo si hay proyecto activo) -->
            <button 
              *ngIf="proyectoId" 
              class="action-button save-button" 
              (click)="guardarProyectoManual()"
              title="Guardar proyecto"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              Guardar
            </button>
            
            <!-- Botón Guardar como Proyecto (solo si NO hay proyecto activo) -->
            <button 
              *ngIf="!proyectoId"
              class="action-button save-as-button" 
              (click)="openSaveProjectModal()"
              title="Guardar como proyecto nuevo"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              Guardar como Proyecto
            </button>
            
            <button class="action-button secondary" (click)="clearCanvas()" title="Limpiar todo">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
              Limpiar Todo
            </button>
            
            <!-- Botón de Exportación con Menú -->
            <div class="export-menu-container">
              <button class="action-button primary export-button" (click)="toggleExportMenu()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Exportar
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dropdown-arrow" [class.rotated]="showExportMenu">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              
              <!-- Menú desplegable -->
              <div class="export-menu" *ngIf="showExportMenu">
                <!-- Opción PNG -->
                <div class="export-menu-item" (click)="showPngOptions = !showPngOptions">
                  <span>PNG</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-arrow" [class.rotated]="showPngOptions">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
                
                <!-- Opciones PNG -->
                <div class="export-submenu" *ngIf="showPngOptions">
                  <div class="export-submenu-item" (click)="exportPng('color')">
                    <span>Con fondo de color</span>
                  </div>
                  <div class="export-submenu-item" (click)="exportPng('transparent')">
                    <span>Con fondo transparente</span>
                  </div>
                </div>
                
                <!-- Opción JPG (mantener compatibilidad) -->
                <div class="export-menu-item" (click)="downloadBanner(); showExportMenu = false">
                  <span>JPG</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Panel de Contenido -->
    <div class="side-panel" [class.open]="activePanel === 'content'">
      <div class="side-panel-header">
        <h2 class="side-panel-title">➕ Contenido</h2>
        <button class="side-panel-close" (click)="closePanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="side-panel-content">
        <!-- Sección de Contenido -->
        <div class="drawer-section">
          <!-- Agregar Texto -->
          <div class="control-section">
            <label class="section-label">Agregar Texto</label>
            
            <div class="control-item">
              <input 
                type="text" 
                [(ngModel)]="textContent"
                class="text-input"
                placeholder="Tu texto aquí"
              />
            </div>

            <div class="control-item">
              <label class="control-label">Fuente</label>
              <select [(ngModel)]="selectedFont" class="font-select">
                <option *ngFor="let font of fonts" [value]="font">{{ font }}</option>
              </select>
            </div>

            <div class="control-item">
              <label class="control-label">Tamaño</label>
              <div class="size-control">
                <input 
                  type="range" 
                  [(ngModel)]="fontSize"
                  min="12"
                  max="72"
                  class="size-slider"
                />
                <span class="size-value">{{ fontSize }}px</span>
              </div>
            </div>

            <div class="control-item">
              <label class="control-label">Color</label>
              <div class="color-picker-group">
                <input 
                  type="color" 
                  [(ngModel)]="textColor"
                  class="color-picker-small"
                />
                <input 
                  type="text" 
                  [(ngModel)]="textColor"
                  class="color-input-small"
                  placeholder="#000000"
                />
              </div>
            </div>


            <!-- Estilos de texto (Negrita, Cursiva, Subrayado) -->
            <div class="control-item">
              <label class="control-label">Estilos</label>
              <div class="text-style-buttons">
                <button 
                  type="button"
                  class="style-button"
                  [class.active]="textBold"
                  (click)="textBold = !textBold"
                  title="Negrita"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
                    <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
                  </svg>
                </button>
                <button 
                  type="button"
                  class="style-button"
                  [class.active]="textItalic"
                  (click)="textItalic = !textItalic"
                  title="Cursiva"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="4" x2="10" y2="4"></line>
                    <line x1="14" y1="20" x2="5" y2="20"></line>
                    <line x1="15" y1="4" x2="9" y2="20"></line>
                  </svg>
                </button>
                <button 
                  type="button"
                  class="style-button"
                  [class.active]="textUnderline"
                  (click)="textUnderline = !textUnderline"
                  title="Subrayado"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path>
                    <line x1="4" y1="21" x2="20" y2="21"></line>
                  </svg>
                </button>
              </div>
            </div>

            <button class="add-button" (click)="addText()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Agregar Texto
            </button>
          </div>

          <!-- Agregar Imagen -->
          <div class="control-section">
            <label class="section-label">Agregar Imagen</label>
            <div class="image-upload-area">
              <input 
                type="file" 
                id="image-upload"
                accept="image/*"
                (change)="onImageSelected($event)"
                class="file-input"
                style="display: none;"
              />
              <button class="upload-button" (click)="triggerImageUpload()" [disabled]="isUploadingImage || isRemovingBackground">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                Subir Imagen
              </button>
              
              <!-- FUNCIONALIDAD DE ELIMINAR FONDO TEMPORALMENTE DESHABILITADA -->
              <!-- Checkbox para eliminar fondo -->
              <!-- <div class="remove-bg-checkbox" style="margin-top: 10px;">
                <label style="display: flex; align-items: center; cursor: pointer; font-size: 14px;">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="removeBackgroundOnUpload"
                    [disabled]="isUploadingImage || isRemovingBackground"
                    style="margin-right: 8px; cursor: pointer;"
                  />
                  <span>Eliminar fondo de imagen</span>
                </label>
              </div> -->
              
              <!-- FUNCIONALIDAD DE ELIMINAR FONDO TEMPORALMENTE DESHABILITADA -->
              <!-- Barra de progreso durante subida/procesamiento -->
              <div *ngIf="isUploadingImage" style="margin-top: 10px;">
                <p class="upload-hint" *ngIf="isUploadingImage">Subiendo imagen...</p>
                <!-- <p class="upload-hint" *ngIf="isRemovingBackground">Eliminando fondo de imagen...</p> -->
                
                <!-- Barra de progreso -->
                <div class="progress-bar-container" style="margin-top: 8px;">
                  <div class="progress-bar" [style.width.%]="backgroundRemovalProgress || (isUploadingImage ? 50 : 0)">
                    <span class="progress-text">{{ backgroundRemovalProgress || (isUploadingImage ? 50 : 0) }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Agregar Formas -->
          <div class="control-section">
            <label class="section-label">Agregar Formas</label>
            
            <div class="control-item">
              <label class="control-label">Tipo de Forma</label>
              <select [(ngModel)]="selectedShapeType" class="font-select">
                <option *ngFor="let shape of shapeTypes" [value]="shape.id">
                  {{ shape.icon }} {{ shape.name }}
                </option>
              </select>
            </div>

            <div class="control-item">
              <label class="control-label">Color de Relleno</label>
              <div class="color-picker-group">
                <input 
                  type="color" 
                  [(ngModel)]="shapeColor"
                  class="color-picker-small"
                />
                <input 
                  type="text" 
                  [(ngModel)]="shapeColor"
                  class="color-input-small"
                  placeholder="#FF0000"
                />
              </div>
            </div>

            <div class="control-item">
              <label class="control-label">Color del Borde</label>
              <div class="color-picker-group">
                <input 
                  type="color" 
                  [(ngModel)]="shapeStrokeColor"
                  class="color-picker-small"
                />
                <input 
                  type="text" 
                  [(ngModel)]="shapeStrokeColor"
                  class="color-input-small"
                  placeholder="#000000"
                />
              </div>
            </div>

            <div class="control-item">
              <label class="control-label">Grosor del Borde</label>
              <div class="size-control">
                <input 
                  type="range" 
                  [(ngModel)]="shapeStrokeWidth"
                  min="0"
                  max="20"
                  class="size-slider"
                />
                <span class="size-value">{{ shapeStrokeWidth }}px</span>
              </div>
            </div>

            <button class="add-button" (click)="addShape()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Agregar Forma
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Panel de Elementos -->
    <div class="side-panel" [class.open]="activePanel === 'elements'">
      <div class="side-panel-header">
        <h2 class="side-panel-title">📋 Elementos</h2>
        <button class="side-panel-close" (click)="closePanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="side-panel-content">
        <div class="elements-list">
          <div 
            *ngFor="let element of canvasElements; trackBy: trackByElementId; let i = index"
            class="element-item"
            [class.active]="isElementActive(element)"
            [class.dragging]="draggedElementIndex === i"
            [draggable]="true"
            (dragstart)="onDragStart($event, i)"
            (dragover)="onDragOver($event, i)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event, i)"
            (dragend)="onDragEnd($event)"
            (click)="selectElement(element)"
          >
            <div class="element-info" (click)="selectElement(element)">
              <span class="element-icon">
                <svg *ngIf="element.type === 'text'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="4 7 4 4 20 4 20 7"></polyline>
                  <line x1="9" y1="20" x2="15" y2="20"></line>
                  <line x1="12" y1="4" x2="12" y2="20"></line>
                </svg>
                <svg *ngIf="element.type === 'image'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                <svg *ngIf="element.type === 'shape'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                </svg>
              </span>
              <span class="element-name">{{ element.name }}</span>
            </div>
            <div class="element-actions">
              <button class="visibility-button" (click)="toggleElementVisibility(element); $event.stopPropagation()" [title]="isElementVisible(element) ? 'Ocultar elemento' : 'Mostrar elemento'">
                <svg *ngIf="isElementVisible(element)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg *ngIf="!isElementVisible(element)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </button>
              <button class="delete-button" (click)="deleteElement(element); $event.stopPropagation()" title="Eliminar">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
            </div>
          </div>
          <p *ngIf="canvasElements.length === 0" class="empty-elements">No hay elementos agregados</p>
        </div>
      </div>
    </div>

    <!-- Panel de Propiedades del Elemento -->
    <div class="side-panel" [class.open]="activePanel === 'properties' && selectedElementForEdit">
      <div class="side-panel-header">
        <h2 class="side-panel-title">⚙️ Propiedades de {{ getElementTypeName() }}</h2>
        <button class="side-panel-close" (click)="closeElementPropertiesModal()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="side-panel-content properties-panel-content" *ngIf="selectedElementForEdit">
        <!-- Propiedades Generales -->
        <div class="properties-section">
          <h3 class="properties-section-title">Posición y Transformación</h3>
          <div class="properties-row">
            <div class="property-item">
              <label class="property-label">Posición X</label>
              <input type="number" [(ngModel)]="elementProperties.left" (change)="onElementPropertyChange()" class="property-input">
            </div>
            <div class="property-item">
              <label class="property-label">Posición Y</label>
              <input type="number" [(ngModel)]="elementProperties.top" (change)="onElementPropertyChange()" class="property-input">
            </div>
          </div>
          <div class="properties-row">
            <div class="property-item">
              <label class="property-label">Rotación (°)</label>
              <input type="number" [(ngModel)]="elementProperties.angle" (change)="onElementPropertyChange()" class="property-input" min="0" max="360">
            </div>
            <div class="property-item">
              <label class="property-label">Opacidad</label>
              <input type="range" [(ngModel)]="elementProperties.opacity" (input)="onElementPropertyChange()" min="0" max="1" step="0.01" class="property-slider">
              <span class="property-value">{{ (elementProperties.opacity * 100).toFixed(0) }}%</span>
            </div>
          </div>
          <div class="properties-row">
            <div class="property-item">
              <label class="property-label">Escala X</label>
              <input type="number" [(ngModel)]="elementProperties.scaleX" (change)="onElementPropertyChange()" class="property-input" min="0.1" max="5" step="0.1">
            </div>
            <div class="property-item">
              <label class="property-label">Escala Y</label>
              <input type="number" [(ngModel)]="elementProperties.scaleY" (change)="onElementPropertyChange()" class="property-input" min="0.1" max="5" step="0.1">
            </div>
          </div>
        </div>

        <!-- Propiedades de Texto -->
        <div class="properties-section" *ngIf="isTextElement()">
          <h3 class="properties-section-title">Propiedades de Texto</h3>
          <div class="property-item">
            <label class="property-label">Texto</label>
            <textarea [(ngModel)]="elementProperties.text" (change)="onElementPropertyChange()" class="property-textarea" rows="3"></textarea>
          </div>
          <div class="properties-row">
            <div class="property-item">
              <label class="property-label">Tamaño de Fuente</label>
              <input type="number" [(ngModel)]="elementProperties.fontSize" (change)="onElementPropertyChange()" class="property-input" min="8" max="200">
            </div>
            <div class="property-item">
              <label class="property-label">Fuente</label>
              <select [(ngModel)]="elementProperties.fontFamily" (change)="onElementPropertyChange()" class="property-select">
                <option *ngFor="let font of fonts" [value]="font">{{ font }}</option>
              </select>
            </div>
          </div>
          <div class="property-item">
            <label class="property-label">Color de Texto</label>
            <div class="color-picker-group">
              <input type="color" [(ngModel)]="elementProperties.fill" (change)="onElementPropertyChange()" class="color-picker">
              <input type="text" [(ngModel)]="elementProperties.fill" (change)="onElementPropertyChange()" class="color-input" placeholder="#000000">
            </div>
          </div>

          <!-- Estilos de texto (Negrita, Cursiva, Subrayado) -->
          <div class="property-item">
            <label class="property-label">Estilos</label>
            <div class="text-style-buttons">
              <button 
                type="button"
                class="style-button"
                [class.active]="elementProperties.fontWeight === 'bold' || elementProperties.fontWeight === '700'"
                (click)="elementProperties.fontWeight = (elementProperties.fontWeight === 'bold' || elementProperties.fontWeight === '700') ? 'normal' : 'bold'; onElementPropertyChange()"
                title="Negrita"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
                  <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
                </svg>
              </button>
              <button 
                type="button"
                class="style-button"
                [class.active]="elementProperties.fontStyle === 'italic'"
                (click)="elementProperties.fontStyle = elementProperties.fontStyle === 'italic' ? 'normal' : 'italic'; onElementPropertyChange()"
                title="Cursiva"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="19" y1="4" x2="10" y2="4"></line>
                  <line x1="14" y1="20" x2="5" y2="20"></line>
                  <line x1="15" y1="4" x2="9" y2="20"></line>
                </svg>
              </button>
              <button 
                type="button"
                class="style-button"
                [class.active]="elementProperties.underline === true"
                (click)="elementProperties.underline = !elementProperties.underline; onElementPropertyChange()"
                title="Subrayado"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path>
                  <line x1="4" y1="21" x2="20" y2="21"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Propiedades de Formas -->
        <div class="properties-section" *ngIf="isShapeElement()">
          <h3 class="properties-section-title">Propiedades de Forma</h3>
          <div class="properties-row" *ngIf="isRectangleElement()">
            <div class="property-item">
              <label class="property-label">Ancho</label>
              <input type="number" [(ngModel)]="elementProperties.width" (change)="onElementPropertyChange()" class="property-input" min="1">
            </div>
            <div class="property-item">
              <label class="property-label">Alto</label>
              <input type="number" [(ngModel)]="elementProperties.height" (change)="onElementPropertyChange()" class="property-input" min="1">
            </div>
          </div>
          <div class="property-item" *ngIf="isCircleElement()">
            <label class="property-label">Radio</label>
            <input type="number" [(ngModel)]="elementProperties.radius" (change)="onElementPropertyChange()" class="property-input" min="1">
          </div>
          <div class="property-item">
            <label class="property-label">Color de Relleno</label>
            <div class="color-picker-group">
              <input type="color" [(ngModel)]="elementProperties.fill" (change)="onElementPropertyChange()" class="color-picker">
              <input type="text" [(ngModel)]="elementProperties.fill" (change)="onElementPropertyChange()" class="color-input" placeholder="#FF0000">
            </div>
          </div>
          <div class="property-item">
            <label class="property-label">Color del Borde</label>
            <div class="color-picker-group">
              <input type="color" [(ngModel)]="elementProperties.stroke" (change)="onElementPropertyChange()" class="color-picker">
              <input type="text" [(ngModel)]="elementProperties.stroke" (change)="onElementPropertyChange()" class="color-input" placeholder="#000000">
            </div>
          </div>
          <div class="property-item">
            <label class="property-label">Grosor del Borde</label>
            <input type="number" [(ngModel)]="elementProperties.strokeWidth" (change)="onElementPropertyChange()" class="property-input" min="0" max="50">
          </div>
        </div>

        <!-- Propiedades de Imagen -->
        <div class="properties-section" *ngIf="isImageElement()">
          <h3 class="properties-section-title">Propiedades de Imagen</h3>
          <p class="property-hint">Las imágenes solo pueden ajustar posición, escala, rotación y opacidad.</p>
          
          <div class="property-item" style="margin-top: 15px;">
            <!-- FUNCIONALIDAD DE ELIMINAR FONDO TEMPORALMENTE DESHABILITADA -->
            <button 
              class="remove-bg-button" 
              disabled
              style="opacity: 0.6; cursor: not-allowed;">
              <span>Funcionalidad próximamente</span>
            </button>
            
            <!-- CÓDIGO COMENTADO - FUNCIONALIDAD DE ELIMINAR FONDO -->
            <!-- <button 
              class="remove-bg-button" 
              (click)="removeImageBackground()"
              [disabled]="isRemovingBackground"
              [class.loading]="isRemovingBackground">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" *ngIf="!isRemovingBackground">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <span *ngIf="!isRemovingBackground">Eliminar Fondo</span>
              <span *ngIf="isRemovingBackground">Procesando...</span>
            </button>
            
            < Barra de progreso -->
            <!-- <div class="progress-bar-container" *ngIf="isRemovingBackground" style="margin-top: 10px;">
              <div class="progress-bar" [style.width.%]="backgroundRemovalProgress">
                <span class="progress-text">{{ backgroundRemovalProgress }}%</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Guardar Proyecto -->
  <div class="modal-overlay" *ngIf="showSaveProjectModal" (click)="closeSaveProjectModal()">
    <div class="properties-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Guardar como Proyecto</h2>
        <button class="modal-close" (click)="closeSaveProjectModal()" [disabled]="isSavingProject">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal-body properties-modal-body">
        <div class="property-item">
          <label class="property-label">Nombre del Proyecto</label>
          <input 
            type="text" 
            [(ngModel)]="projectName" 
            class="property-input"
            placeholder="Ingresa el nombre del proyecto"
            [disabled]="isSavingProject"
            (keyup.enter)="!isSavingProject && guardarComoProyecto()"
            autofocus
          />
          <p class="property-hint">Este nombre aparecerá en tu lista de proyectos</p>
        </div>
        <div class="property-item">
          <label class="property-label">Color del Icono</label>
          <div class="color-picker-group">
            <input 
              type="color" 
              [(ngModel)]="projectColor" 
              class="color-picker"
              [disabled]="isSavingProject"
            />
            <input 
              type="text" 
              [(ngModel)]="projectColor" 
              class="color-input" 
              placeholder="#3b82f6"
              [disabled]="isSavingProject"
            />
          </div>
          <p class="property-hint">Este color se usará para el icono del proyecto en la lista</p>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          class="modal-button secondary" 
          (click)="closeSaveProjectModal()"
          [disabled]="isSavingProject"
        >
          Cancelar
        </button>
        <button 
          class="modal-button primary" 
          (click)="guardarComoProyecto()"
          [disabled]="isSavingProject || !projectName || !projectName.trim()"
        >
          <span *ngIf="!isSavingProject">Guardar</span>
          <span *ngIf="isSavingProject">Guardando...</span>
        </button>
      </div>
    </div>
  </div>
  <footer>
    <div class="footer-container">
      <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
      <div class="footer-links">
        <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
        <a routerLink="/support" data-i18n="footerContact">Soporte</a>
      </div>
    </div>
  </footer>
</div>
